type ItemListElementT = {
  position: number;
  name: string;
  item: string;
};

const BreadcrumbJsonLd = ({
  itemListElement,
  host,
}: {
  itemListElement: ItemListElementT[];
  host: string;
}) => {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: itemListElement.map((item) => ({
      '@type': 'ListItem',
      ...item,
      item: `https://${host}${item.item}`,
    })),
  };

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
};

export default BreadcrumbJsonLd;
